import request from './request'

// 删除单个场景
export function deleteHotspotData(data,access_token) {
  return request({
    url: '/tblHotspot/deleteHotspotData',
    method: 'post',
    headers: {
      'Authorization':'Bearer ' +access_token
    },
    params: data,
  });
}

// 修改场景名称
export function tblMediaAssetsEdit(data,access_token) {
	return request({
		url: '/tblMediaAssets/updateByFileName',
		method: 'post',
    // headers: {
    //   'Authorization':'Bearer ' +access_token
    // },
		data: data,
	});
}

// 新增热点信息
export function addTblHotspot(data,access_token) {
  return request({
    url: `/tblHotspot/save`,
    method: 'post',
    headers: {
      'Authorization':'Bearer ' +access_token
    },
    data
  })
}
// 通过id查询
export function tblHotspotById(id,access_token) {
  return request({
    url: `/tblHotspot/${id}`,
    method: 'get',
    headers: {
      'Authorization':'Bearer ' +access_token
    }
  })
}
// 分页查询
export function carModelPage(data) {
  return request({
    url: `/carModel/page`,
    method: 'get',
    params: data
  })
}
// 获取视频列表
export function tblMediaAssetsId(data,access_token) {
  console.log(access_token)
  return request({
    url: `/tblMediaAssets/page`,
    method: 'get',
    headers: {
      'Authorization':'Bearer ' +access_token
    },
    params: data
  })
}
// 分页查询所有
export function tblCategoriesPage(data) {
  return request({
    url: `/admin/tblCategories/page`,
    method: 'get',
    params: data
  })
}

// 是否收藏
export function isFavorites(data,access_token) {
  return request({
    url: `/tblFavorites/isFavorites`,
    headers: {
      'Authorization':'Bearer ' +access_token
    },
    method: 'get',
    params: data
  })
}
// 新增收藏
export function tblFavorites(data,access_token) {
  return request({
    url: `/tblFavorites/save`,
    headers: {
      'Authorization':'Bearer ' +access_token
    },
    method: 'post',
    data
  })
}
//图标库

export function tblIconTemplate(data) {
  return request({
    url: `/tblIconTemplate/page`,
    method: 'get',
    params: data
  })
}
//是否收藏
// export const isFavorites = data => request.get(`/tblFavorites/isFavorites`, data)
